interface NotificationDataOptions {
  id?: string;
  showClose?: boolean;
  icon?: string;
  position?: string;
  iconType?: string;
  duration?: number;
  customClass?: string;
  clickToClose?: boolean;
  placement?: string;
}

export const notificationDataOptions: NotificationDataOptions = {
  id: 'global-notification-message',
  showClose: true,
  icon: 'icon-error-fill',
};
